// Raw markdown, unrendered: the history is developer-facing.
export function ChangelogPage() {
  return (
    <pre className="min-h-svh whitespace-pre-wrap bg-background p-6 font-mono text-sm text-foreground">
      {__APP_CHANGELOG__}
    </pre>
  );
}
